import axios from 'axios';
import {V1API} from "../../../_helpers/APIPath";
import {encode, decode} from "../../dataMagic";
import {populateStore, performNetworkCall, buildFormData} from "@/store/asyncHelper";


const keyList = {
    smsUpdate : 'VOICE_UPDATE',
    smsDelete : 'VOICE_DELETE'
};

const mutations = {};
const store = {};

populateStore(store, mutations, keyList, false);

export default {
    namespaced: true,

    state : {
        
        pledge:[],
        submitLoading: false,
        pledgeLoading: false,
        pledgeError: false,
        ...store
    },

    mutations : {
        ...mutations,
       
        SET_PLEDGE(state, pledge) {
            state.pledge = pledge;
        },
        SUBMIT_LOADING (state, loading) {
            state.submitLoading = loading;
        },
        PLEDGE_LOADING (state, loading) {
            state.pledgeLoading = loading;
        },
        PLEDGE_ERROR (state, hasError) {
            state.pledgeError = hasError;
        },
        
    },

    actions: {


        async fetchPledge ({ commit }) {
            commit('PLEDGE_LOADING', true);
            commit('PLEDGE_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try{
                let result = await axios.get(V1API.get_pledge_signing_list, config);
                let response = result.data

                commit('SET_PLEDGE', response.data);

            } catch(error) {
                commit('PLEDGE_ERROR', true);
            }
            finally {
                commit('PLEDGE_LOADING', false);
            }
        },





       








    },

    getters: {}
}
